import { v1ApiClient } from '@/services';
import type {
  PathParams,
  RequestBody,
  ResponseBody,
} from '@/shared/api/generated';

type PreviewNotificationPath = '/v1/workspaces/{workspace_id}/notifications/preview';

type PreviewNotificationParams = PathParams<PreviewNotificationPath, 'post'> &
  RequestBody<PreviewNotificationPath, 'post'>;
type PreviewNotificationResponse = ResponseBody<PreviewNotificationPath, 'post'>;

/**
 * 알림 미리보기
 */
export const previewNotification = ({
  workspace_id,
  ...body
}: PreviewNotificationParams): Promise<PreviewNotificationResponse> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/notifications/preview`, body)
    .then((res) => res.data);
